import { Component, Inject, Input, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Vehicule } from 'src/app/user/user.model';
import { UserServiceImpl } from 'src/app/user/service/user.service';
import { map } from 'rxjs/operators';

@Component({
    selector: 'app-udes-view-component',
    templateUrl: './udes-view-component.component.html',
    styleUrls: ['./udes-view-component.component.scss'],
})
export class UdesViewComponentComponent implements OnInit {
    permits = [];
    @Input() vehicle: Vehicule;
    @Input() toggleView = true;
    constructor(
        public userService: UserServiceImpl,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: Vehicule,
    ) {}

    ngOnInit(): void {
        if (this.data) {
            this.vehicle = { ...this.data };
        }
        this.userService
            .getPermits(this.vehicle)
            .pipe(
                map((data: any) => {
                    this.permits = data;
                }),
            )
            .subscribe();
    }
}
